module.exports = __webpack_public_path__ + "static/media/zappertak-2.9759cf2e.jpg";